import React from 'react';
import Helmet from 'react-helmet';

import Header from 'src/components/header';
import Footer from 'src/components/footer';

import './privacy.css';

export default class Privacy extends React.Component {
  render() {
    return (
      <div>
        <Helmet
          title="Privacy policy"
          meta={[{ property: 'og:title', content: 'Privacy policy' }]}
        />
        <Header />
        <div className="page-bg" />
        <section className="page privacy">
          <h2 className="privacy-title">Privacy Policy</h2>
          <h5 className="privacy-subtitle">Last Modified: 8/27/2017</h5>
          <div className="privacy-body">
            <p>
              This privacy policy (the “<strong>Privacy Policy</strong>”) describes how Playerbase,
              Inc. (referred to as “<strong>we</strong>”, “<strong>our</strong>”, “<strong>
                us
              </strong>”) collects, uses, and stores information of users (“<strong>you</strong>”)
              of the Services. As used in this Privacy Policy “you” includes the Customer
              authorizing your use, if you are not the Customer. This Privacy Policy, together with
              SAAS Services Agreement (“<strong>Agreement</strong>”) separately agreed to between us
              and you and incorporating this Privacy Policy, establishes the legal terms and
              conditions of the agreement between us governing the submission of the Information and
              our use of it in performing the Services. All capitalized terms used in this policy
              and not otherwise defined here will have the meanings assigned to them in the
              Agreement. By submitting information, you agree to be bound by this policy and allow
              the information to be used in the manner specified in this policy.
            </p>
            <p>
              <strong>1. The Information We Collect And Store</strong>
            </p>
            <p>We may collect and store the following information when you use the Services:</p>
            <p>
              <em>Information You Provide</em>. When you (or the Customer) register an account, we
              collect some personal information that identifies, relates to, describes, or is
              capable of being associated with you or your personnel (“<strong>
                Personal Information
              </strong>”), such as names, phone numbers, credit card or other billing information,
              email addresses and home and business postal addresses or social media handles. If you
              contact us for support, we will keep an internal record of what support was given.
            </p>
            <p>
              <em>UGC</em>. We collect and store the information you Upload to the Services (“<strong>
                UGC
              </strong>”).
            </p>
            <p>
              <em>Log Data</em>. When you use the Services, we automatically record information from
              your Device, its software, and your activity using the Services. This may include the
              Device’s Internet Protocol (“<strong>IP</strong>”) address, browser type, the web page
              visited before you came to our website, information you search for on our website,
              locale preferences, identification numbers associated with your Devices, your mobile
              carrier, date and time stamps associated with transactions, system configuration
              information, metadata concerning your UGC, and other interactions with the Services.
              As used in this Privacy Policy, “<strong>Device</strong>” means any computer used to
              access the Services, including a desktop, laptop, mobile phone, tablet, or other
              electronic device.
            </p>
            <p>
              <em>Cookies</em>. We also use “cookies” and like technologies to collect information
              and improve the Services. A cookie is a small data file that we transfer to your
              Device. We may use “persistent cookies” to save your registration ID and login
              password for future logins to the Services. We may use “session ID cookies” to enable
              certain features of the Services, to better understand how you interact with the
              Services and to monitor aggregate usage and web traffic routing on the Services. You
              can instruct your browser, by changing its options, to stop accepting cookies or to
              prompt you before accepting a cookie from the websites you visit. If you do not accept
              cookies, however, you may not be able to use all aspects of the Services.
            </p>
            <p>
              <em>Local Storage and Collection</em>. We may collect and store information (including
              Personal Information) locally on your Device using mechanisms such as browser web
              storage (including HTML5) and application data caches.
            </p>
            <p>
              <em>Geo-Location Information</em>. Some Devices allow applications to access real-time
              location-based information (for example, GPS or sensor data from your Device that may
              provide information on nearby Wi-Fi access points and cell towers). We may collect
              such information from your Device. Some photos and videos you Upload to your account
              may contain recorded location information. If you do not wish to share files embedded
              with your geo-location information with us, please do not Upload them. If you do not
              want to store location data in your photos or videos, please consult the documentation
              for your camera to turn off that feature. Some of the information we collect from a
              Device, for example IP address, can sometimes be used to approximate a Device’s
              location. Finally, some browsers share your location information (either the location
              registered with your account or gleaned from other geo-location methods) with sites
              you visit and we may obtain location information about you in this way. If you do not
              wish us to receive this information, please configure your browser not to share it.
            </p>
            <p>
              <strong>2. How We Use Personal Information</strong>
            </p>
            <p>
              <em>Personal Information</em>. In the course of using the Services, we may collect
              Personal Information. Personal Information is or may be used: (i) to provide and
              improve the Services, (ii) to administer your use of the Services, including
              communicating with you about the Services and your account, (iii) to better understand
              your needs and interests, (iv) to personalize and improve your experience, (v) to
              provide or offer software updates and product announcements, and (vi) perform
              functions as otherwise described to you at the time of collection. If you no longer
              wish to receive communications from us, please contact&nbsp;<a href="mailto:support@playerbase.io">
                support@playerbase.io
              </a>.
            </p>
            <p>
              <em>Financial Information</em>. We may use financial information or payment method
              information to process payment for the products you order, enroll you in the discount,
              rebate, and other programs in which you elect to participate, to protect against or
              identify possible fraudulent transactions, and otherwise as needed to manage our
              business.
            </p>
            <p>
              <em>Analytics</em>. We may use all of the information we collect, in general for the
              above purposes and to monitor and analyze use of the Services, for the Services’
              technical administration, to increase the Services’ functionality and
              user-friendliness, and to verify users have the authorization needed for the Services
              to process their requests.
            </p>
            <p>
              <em>Server Location</em>. We may process your personal information on a server located
              outside the country where you live.
            </p>
            <p>
              <strong>3. Information Sharing and Disclosure</strong>
            </p>
            <p>
              <em>Your Use</em>. If you are an authorized user, we may share the information you
              provide to us with the Customer authorizing your use.
            </p>
            <p>
              <em>Services Providers, Business Partners and Others</em>. We may share information,
              including Personal Information, with third parties that perform certain services on
              our behalf. These services may include fulfilling orders, providing customer service
              and marketing assistance, performing business and sales analysis, ad tracking and
              analytics, supporting the Services’ functionality and other features offered through
              the Services. We may also share your name, contact information and credit card
              information with our service providers who process credit card payments. These service
              providers may have access to Personal Information needed to perform their functions
              but are not permitted to share or use such information for any other purposes and are
              required to use the information in conformance with this Privacy Policy.
            </p>
            <p>
              <em>Third-Party Applications</em>. We may share your information with a third party
              application with your consent, for example when you choose to access the Services
              through such an application. We are not responsible for what those parties do with
              your information, so you should make sure you trust the application and that it has a
              privacy policy acceptable to you.
            </p>
            <p>
              <em>Compliance with Laws and Law Enforcement Requests; Protection of Our Rights</em>.
              We may disclose to third parties UGC you Upload to your account and information about
              you that we collect when we have a good faith belief that disclosure is reasonably
              necessary to (i) comply with a law, regulation or compulsory legal request; (b)
              protect the safety of any person from death or serious bodily injury; (c) prevent
              fraud or abuse of us or our users; (d) to protect our property rights; or (e) enforce
              the Agreement and Policies, including investigation of potential violations. If we
              provide your UGC to a law enforcement agency as set forth above, we will remove
              encryption, if any, before providing it to law enforcement.
            </p>
            <p>
              <em>Business Transfers</em>. If we are involved in a merger, acquisition, or sale of
              all or a portion of our assets, your information may be transferred as part of that
              transaction, but we will notify you (for example, via email and/or a prominent notice
              on our website) of any change in control or use of your Personal Information or UGC,
              or if either become subject to a different privacy policy. We will also notify you of
              choices you may have regarding the information.
            </p>
            <p>
              <em>Non-private or Non-Personal Information</em>. We may share aggregated,
              non-personally identifiable information publicly. For example, we may share
              information publicly to show trends about the general use of the Services with the
              press, in our marketing materials or with our business partners. We may collate or
              connect non-personally identifiable information with your Personal Information, in
              which case the resulting personally identifiable information will be treated as
              Personal Information.
            </p>
            <p>
              <strong>4. Changing or Deleting Your Information</strong>
            </p>
            <p>
              We aim to provide you with access to your Personal Information. You should direct any
              request to <a href="mailto:support@playerbase.io">support@playerbase.io</a>. We will
              use commercially reasonable efforts to respond to requests within 30 days. If any
              Personal Information is wrong, we strive to give you ways to update it quickly or to
              delete it – unless we have to keep that information for legitimate business or legal
              purposes. When updating your Personal Information, we may ask you to verify your
              identity before we can act on your request.
            </p>
            <p>
              We may reject requests that are unreasonably repetitive, require disproportionate
              technical effort (for example, developing a new system or fundamentally changing an
              existing practice), risk the privacy of others, or would be extremely impractical (for
              instance, requests concerning information residing on backup systems).
            </p>
            <p>
              Where we can provide information access and correction, we will do so for free, except
              where it would require a disproportionate effort. We aim to maintain the Services in a
              manner that protects information from accidental or malicious destruction. Because of
              this, after you delete information in your account, we may not immediately delete
              residual copies from our active servers and may not remove information from our backup
              systems.
            </p>
            <p>
              <strong>5. Data Retention</strong>
            </p>
            <p>
              We will retain your information for as long as your account is active or as needed to
              provide you services. We may retain and use your information as necessary to comply
              with our legal obligations, meet regulatory requirements, resolve disputes, prevent
              fraud and abuse or enforce our agreements. Consistent with these requirements, we will
              use commercially reasonable efforts to delete your information quickly upon request.
              Please note, however, that there might be latency in deleting information from our
              servers and backed-up versions might exist after deletion. In addition, we do not
              delete from our servers files that you have in common with other users or, if you are
              an authorized user, we will not deleted your information unless the Customer
              authorizing your use requests it.
            </p>
            <p>
              <strong>6. Third-Party Sites</strong>
            </p>
            <p>
              Our website may include links to other websites whose privacy practices may differ
              from those of Playerbase. If you submit information to any of those websites, your
              information is governed by their privacy statements. We encourage you to carefully
              read the privacy statement of any website you visit.
            </p>
            <p>
              <strong>7. Security</strong>
            </p>
            <p>
              The security of your information is important to us. When you enter sensitive
              information (such as a password) on our order forms, we encrypt the transmission of
              that information using transport layer security (TLS).
            </p>
            <p>
              We follow generally accepted standards to protect the information submitted to us,
              both during transmission and once we receive it. No method of electronic transmission
              or storage is 100% secure, however. Therefore, we make no guarantees of security. If
              you have any questions about security on our website, you can contact us at&nbsp;
              <a href="mailto:support@playerbase.io">support@playerbase.io</a>.
            </p>
            <p>
              <strong>8. Our Policy Toward Children</strong>
            </p>
            <p>
              The Services is not directed or available to persons under 13. We do not knowingly
              collect Personal Information from children under 13. If a parent or guardian becomes
              aware that his or her child has established an account in violation of our policies
              and has provided us with Personal Information without their consent, he or she should
              contact us at <a href="mailto:support@playerbase.io">support@playerbase.io</a>. If we
              become aware that a child under 13 has established an account and/or provided us with
              Personal Information, we will close that account and take steps to delete that
              information from our files.
            </p>
            <p>
              <strong>9. California Residents</strong>
            </p>
            <p>
              California Civil Code Section 1798.83, known as the “Shine The Light” law, permits our
              customers who are California residents to request and obtain from us a list of what
              personal information (if any) we disclosed to third parties for direct marketing
              purposes in the preceding calendar year and the names and addresses of those third
              parties. Requests may be made only once a year and are free of charge. Under Section
              1798.83, we currently do not share any personal information with third parties for
              their direct marketing purposes.
            </p>
            <p>
              <strong>10. Contacting Us</strong>
            </p>
            <p>
              If you have any questions about this Privacy Policy, please contact us at&nbsp;<a href="mailto:support@playerbase.io">
                support@playerbase.io
              </a>.
            </p>
            <p>
              <strong>11. Changes to our Privacy Policy</strong>
            </p>
            <p>
              This Privacy Policy may change from time to time. We will not reduce your rights under
              this Privacy Policy without your explicit consent. We will post any Privacy Policy
              changes on this page and, if the changes are significant, we may provide a more
              prominent notice (including, for certain services, email notification of Privacy
              Policy changes). We may make changes without notifying you, however. By continuing to
              use the Services after those changes become effective, you agree to be bound by the
              revised Privacy Policy, whether or not we provide you with notice of the changes. So
              you should visit this policy periodically to familiarize yourself its current terms.
            </p>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/privacy.js